import { useCallback } from 'react';

import { Input } from '@tmapy/style-guide';

import type { DataComponent } from '../../types';
import { ReadOnlyFormField } from '../../components/ReadOnlyFormField';
import { getLocaleDateString } from '../../utils/date/getLocaleDateString';

import { InlineViewComponentMap } from './InlineViewComponentMap';

export const DateInput: DataComponent = ({
  data,
  onChange,
  validate,
  isRequired,
  isReadOnly,
  loading,
  errors,
  path,
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent, eventData: { value: string }) => {
      onChange?.(eventData.value);
    },
    [onChange],
  );

  if (isReadOnly) {
    return (
      <ReadOnlyFormField>
        <InlineViewComponentMap.Date
          loading={loading}
          data={data}
          errors={errors}
          path={path}
          variables={null}
          isReadOnly
          isRequired={isRequired}
        />
      </ReadOnlyFormField>
    );
  }

  const min = getLocaleDateString(validate?.min);
  const max = getLocaleDateString(validate?.max);

  return (
    <Input
      type='date'
      value={data}
      min={min}
      max={max}
      isRequired={isRequired}
      isInvalid={!!errors.length}
      isDisabled={loading}
      onChange={handleChange}
    />
  );
};
